import React from 'react';
import PropTypes from 'prop-types';
import "./SensorHistoryList.css";
import BaseList from '../../../components/BaseList';
import { ITEM_NUM_PER_PAGE, MAX_PAGE } from 'constants/config';
import { useSensorGroups } from 'context/SensorGroupsContext';
import { TEXT_DATA_RECEIVED_DATETIME, TEXT_FLOOD_GATE_OPENING_LEVEL, TEXT_INNER_WATER_LEVEL, TEXT_OUTER_WATER_LEVEL, TEXT_POWER_VOLTAGE, TEXT_STATUS, TEXT_STATUS_DETAIL, TEXT_VALUE } from 'constants/message';
import { hexToRGB } from 'utils/function';
import Icon, { IconList } from 'components/Icon';
import { SensorType } from 'models';
import { FLOOD_GATE_MESSAGES } from 'utils/constanst';

const propTypes = {
  sensor: PropTypes.object,
  sensorHistories: PropTypes.array,
  curPage: PropTypes.number,
  onPageChange: PropTypes.func,
  itemNumPerPage: PropTypes.number
};
const defaultProps = {
  sensor: {},
  sensorHistories: [],
  curPage: 1,
  onPageChange: (newPage) => { },
  itemNumPerPage: ITEM_NUM_PER_PAGE
};
const SensorHistoryList = (props) => {
  /*** States and Variables ***/
  const { sensorGroups } = useSensorGroups();
  const targetGroup = sensorGroups?.find(g => g.id === props.sensor.groupId);
  /*** Processing ***/
  /*** Sub Components ***/
  const renderHeader = () => {
    return <div className='sensor_history_list_header'>
      <div className={`sensor_history_list_header_cell ${targetGroup.type === SensorType.CAMERA ? 'camera_sensor' : ''}`}>
        {TEXT_DATA_RECEIVED_DATETIME}
      </div>
      <div className={`sensor_history_list_header_cell ${targetGroup.type === SensorType.CAMERA ? 'camera_sensor' : ''}`}>
        {TEXT_STATUS}
        <Icon
          icon={IconList.iconSort}
          iconStyle='sensor_history_list_up_arrow' />
      </div>
      {targetGroup.type === SensorType.FLOOD ?
        <div className='sensor_history_list_header_cell'>
          {TEXT_VALUE}
        </div> :
        targetGroup.type === SensorType.FLOOD_GATE ? <>
          <div className='sensor_history_list_header_cell'>
            {TEXT_FLOOD_GATE_OPENING_LEVEL}
          </div>
          <div className='sensor_history_list_header_cell'>
            {TEXT_OUTER_WATER_LEVEL}
          </div>
          <div className='sensor_history_list_header_cell'>
            {TEXT_INNER_WATER_LEVEL}
          </div>
          <div className='sensor_history_list_header_cell'>
            {TEXT_POWER_VOLTAGE}
          </div>
          <div className='sensor_history_list_header_cell'>
            {TEXT_STATUS_DETAIL}
          </div>
        </> : targetGroup.type === SensorType.GENERAL ?
          <>
            {Array.from({ length: 5 }).map((_, i) => {
              const name = props.sensor.data?.[`nameSignal${4 - i}`];
              if (!name) return null
              return <div className='sensor_history_list_header_cell'>
                {name}
              </div>
            })}
            {Array.from({ length: 10 }).map((_, i) => {
              const name = props.sensor.data?.[`nameContact${9 - i}`];
              if (!name) return null
              return <div className='sensor_history_list_header_cell'>
                {name}
              </div>
            })}
            {props.sensor.data.connectMethod !== "SOCKET" && <div className='sensor_history_list_header_cell'>
              {TEXT_POWER_VOLTAGE}
            </div>}
          </> :
          <>
            <div className='sensor_history_list_header_cell camera_sensor'>
              入力プロンプト
            </div>
            <div className='sensor_history_list_header_cell camera_sensor'>
              出力結果
            </div>
          </>
      }
    </div>
  }
  const renderItem = (item) => {
    const statusColor = targetGroup?.messages[item.status]?.color;
    return (
      <div className='sensor_history_list_row'>
        <div className={`sensor_history_list_cell ${targetGroup.type === SensorType.CAMERA ? 'camera_sensor' : ''}`}>
          {item.tx}
        </div>
        <div className={`sensor_history_list_cell ${targetGroup.type === SensorType.CAMERA ? 'camera_sensor' : ''}`}>
          <div
            className='sensor_history_list_status'
            style={{
              backgroundColor: statusColor,
              color: hexToRGB(statusColor) >= 400 ? 'black' : 'white'
            }}>
            {targetGroup.messages[item.status].value}
          </div>
        </div>
        {targetGroup.type === SensorType.FLOOD ?
          <div className='sensor_history_list_cell'>
            -
          </div> : targetGroup.type === SensorType.FLOOD_GATE ?
            <>
              <div className='sensor_history_list_cell'>
                {(item.data.gateOpeningLevel?.toFixed(props.sensor.data?.openingLevelDisplay || 0) || '') + props.sensor.data?.gateOpeningUnit}
              </div>
              <div className='sensor_history_list_cell'>
                {item.data.outerWaterLevel?.toFixed(2) + 'm'}
              </div>
              <div className='sensor_history_list_cell'>
                {item.data.innerWaterLevel?.toFixed(2) + 'm'}
              </div>
              <div className='sensor_history_list_cell'>
                {item.data.powerVoltage?.toFixed(1) + 'V'}
              </div>
              <div className='sensor_history_list_cell'>
                {item.data.allStatuses?.map(s => FLOOD_GATE_MESSAGES[s]).filter(s => !!s).join('、')}
              </div>
            </> : targetGroup.type === SensorType.GENERAL ?
              <>
                {Array.from({ length: 5 }).map((_, i) => {
                  const nameSignal = props.sensor.data?.[`nameSignal${4 - i}`];
                  if (!nameSignal) return null
                  const value = item.data[`a${4 - i}`]
                  const unit = item.data[`a${4 - i}Unit`]
                  const decimalPartLength = props.sensor.data?.[`decimalPartLength${4 - i}`] || 0;
                  return <div className='sensor_history_list_header_cell'>
                    {Number(value).toFixed(decimalPartLength)} {unit}
                  </div>
                })}
                {Array.from({ length: 10 }).map((_, i) => {
                  const nameContact = props.sensor.data?.[`nameContact${9 - i}`];
                  if (!nameContact) return null
                  const value = item.data[`s${9 - i}`]
                  return <div className='sensor_history_list_header_cell'>
                    {value}
                  </div>
                })}
                {props.sensor.data.connectMethod !== "SOCKET" && <div className='sensor_history_list_cell'>
                  {item.data.powerVoltage.toFixed(1) + 'V'}
                </div>}
              </> :
              <>
                <div className='sensor_history_list_cell camera_sensor'>
                  <span>{item.data.prompt}</span>
                  <div className='sensor_history_list_camera_popup'>
                    {item.data.prompt}
                  </div>
                </div>
                <div className='sensor_history_list_cell camera_sensor' >
                  <span>{item.data.response}</span>
                  <div className='sensor_history_list_camera_popup'>
                    {item.data.response}
                  </div>
                </div>
              </>
        }
      </div>
    )
  }

  /*** Event Handlers ***/
  /*** Main Render ***/
  return <BaseList
    items={props.sensorHistories}
    renderHeader={renderHeader}
    renderItem={renderItem}
    curPage={props.curPage}
    onPageChange={props.onPageChange}
    itemNumPerPage={props.itemNumPerPage}
    isNew={true}
    pageNum={props.pageNum}
    maxPage={MAX_PAGE}
    maxItems={MAX_PAGE * props.itemNumPerPage} />;

}
SensorHistoryList.propTypes = propTypes;
SensorHistoryList.defaultProps = defaultProps;
export default SensorHistoryList;